import { http, setFormData } from '@/utils/http'
import { AGENCY_FETCH, AGENCY_CREATE, AGENCY_UPDATE } from '@/store/actions/agency'

const state = {
  agencies: []
}

const getters = {
  agencies: state => state.agencies,
  agenciesAsOptions: state => {
    let activeAgencies = state.agencies.filter(agency => agency.status === 'active')
    activeAgencies = activeAgencies.sort((a, b) => {
      if (a.name < b.name) return -1
      if (a.name > b.name) return 1
      return 0
    })
    return activeAgencies.map(
      agency => ({ text: agency.name, value: agency._id })
    )
  },
  agencyName: state => (id) => { // get state name by id
    const agency = state.agencies.find(agency => agency._id === id)
    return agency !== undefined ? agency.name : ''
  } 
}

const mutations = {
  [AGENCY_FETCH]: (state, payload) => {
    state.agencies = [ ...payload ]
  },
  [AGENCY_UPDATE]: (state, payload) => {
    const updatedAgencies = state.agencies.map(
      agency => (agency._id === payload._id ? Object.assign(agency, payload) : agency)
    )
    state.agencies = updatedAgencies
  }
}

const actions = {
  [AGENCY_FETCH]: ({ commit }) => {
    return new Promise((resolve, reject) => {
      http.get('agency/read_all')
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(AGENCY_FETCH, response.data)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [AGENCY_CREATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('agency/create', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  },
  [AGENCY_UPDATE]: ({ commit }, payload) => {
    return new Promise((resolve, reject) => {
      const params = setFormData(payload)
      http.post('agency/update', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            commit(AGENCY_UPDATE, payload)
            resolve(response)
          }
          else {
            reject(response)
          }
        })
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
